import React from "react";
import Seo from "../Seo/Seo";
import "./FacilityRules.css";

const FacilityRules = () => {
  return (
    <>
      <Seo
        title="Facility & Game Rules | ZealFC"
        description="Read the ZealFC facility and game rules before joining matches."
        canonicalPath="/facility-rules"
      />
      <div className="facility-rules">
        <h1>ZealFC Facility &amp; Game Rules</h1>
        <p><strong>Last updated:</strong> March 7, 2026</p>

        <h2>1. Acceptance of Rules</h2>
        <p>
          By entering the facility or joining a game via ZealFC, the participant confirms they have read and accept these rules.
        </p>
        <p>The organizer or host may require additional stadium-specific rules.</p>

        <h2>2. Eligibility &amp; Minors</h2>
        <p>
          Participation is for persons aged 16+ unless the facility explicitly allows younger participants.
        </p>
        <p>
          Participants under 18 may participate only with written consent from a parent or legal guardian and under adult supervision if required by the facility.
        </p>

        <h2>3. Prohibited Conduct (Zero Tolerance)</h2>
        <p>It is forbidden to:</p>
        <ul>
          <li>Participate while under the influence of alcohol, drugs, or similar substances.</li>
          <li>Bring or consume alcohol or intoxicating substances on the premises unless explicitly allowed by the facility.</li>
          <li>Smoke or vape in non-designated areas.</li>
          <li>Bring dangerous items such as weapons, fireworks, or glass containers.</li>
          <li>Damage property, remove equipment, or misuse facility infrastructure.</li>
          <li>Use abusive language, harassment, violence, discrimination, or threatening behavior.</li>
        </ul>

        <h2>4. Safety &amp; Equipment</h2>
        <ul>
          <li>Participants must wear appropriate sportswear and clean sports footwear suited to the surface.</li>
          <li>For artificial turf, only turf, TF, or indoor shoes may be used as required by the facility. Metal studs are forbidden.</li>
          <li>Players must warm up properly and play responsibly to reduce injury risk.</li>
          <li>Do not move goals or equipment unless authorized. If moved, they must be secured and returned safely.</li>
        </ul>

        <h2>5. Cleanliness &amp; Respect</h2>
        <ul>
          <li>Keep the facility clean and dispose of trash in bins.</li>
          <li>Respect staff instructions and other users of the facility.</li>
          <li>
            Lockers or keys, if provided, are the participant&apos;s responsibility. Lost or damaged keys may be charged per the facility&apos;s price list.
          </li>
        </ul>

        <h2>6. Bookings, Attendance &amp; Punctuality</h2>
        <ul>
          <li>Arrive 10 to 15 minutes early for check-in and warm-up.</li>
          <li>If you cannot attend, cancel as early as possible so someone else can take the spot.</li>
        </ul>

        <h2>7. Payments, Credits &amp; Cancellations (ZealFC Policy)</h2>
        <ul>
          <li>Game participation may require credits, whether subscription or permanent. Credits are deducted on signup.</li>
          <li>Cancellations made 48 hours or more before the game start time are eligible for a credit refund. Later cancellations may not be refunded.</li>
          <li>
            If the facility cancels due to weather, technical issues, or similar reasons, ZealFC will handle refunds or credits according to the game&apos;s payment method and the facility agreement.
          </li>
        </ul>

        <h2>8. Liability &amp; Health Disclaimer</h2>
        <ul>
          <li>Participation is at the participant&apos;s own risk. Each participant confirms they have no medical contraindications to physical activity.</li>
          <li>The facility and ZealFC are not responsible for injuries.</li>
          <li>Personal belongings are the participant&apos;s responsibility. Use lockers if available.</li>
        </ul>

        <h2>9. Media (Photos / Video)</h2>
        <ul>
          <li>The facility or host may take photos or videos for organizational or promotional purposes.</li>
          <li>Participants may request removal of identifiable content where applicable.</li>
        </ul>

        <h2>10. Data Protection (GDPR)</h2>
        <ul>
          <li>ZealFC processes personal data to organize games, manage accounts and credits, and provide support.</li>
          <li>Participants have rights to access, correction, deletion, restriction, and complaint to the relevant supervisory authority.</li>
        </ul>

        <h2>11. Enforcement</h2>
        <ul>
          <li>The host or facility manager may remove a participant for violating these rules without refund.</li>
          <li>Repeated violations may result in account suspension.</li>
        </ul>

        <h2>12. Changes</h2>
        <p>
          ZealFC and or the facility may update these rules. The latest version will be available on the stadium or game page.
        </p>
      </div>
    </>
  );
};

export default FacilityRules;
